import { render, staticRenderFns } from "./Text_v1.vue?vue&type=template&id=3ccc1108&scoped=true&lang=pug"
import script from "./Text_v1.vue?vue&type=script&lang=js"
export * from "./Text_v1.vue?vue&type=script&lang=js"
import style0 from "./Text_v1.vue?vue&type=style&index=0&id=3ccc1108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccc1108",
  null
  
)

export default component.exports